import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import { Langs, LiveInspectorData } from "types/types";
import React, { ReactNode } from "react";
import cn from "classnames";
import locale from "components/HeroBlock/locale";

export type HeroBlockProps = {
  theme: "dark" | "light";
  iconImage?: string;
  badgeType?: "promo" | "new" | "deal" | "cashback";
  title: string;
  titleSize: "sm" | "md" | "lg" | "xl";
  TitleTag: "h1" | "h2";
  price?: string;
  description: ReactNode;
  checkList?: ReactNode;
  listCta: ReactNode;
  node_locale: Langs;
  liveInspector?: LiveInspectorData;
};

const HeroBlock = ({
  theme,
  iconImage,
  badgeType,
  title,
  titleSize,
  TitleTag,
  price,
  description,
  checkList,
  listCta,
  node_locale,
  liveInspector,
}: HeroBlockProps) => {
  const getBadgeTheme = () => {
    if (!badgeType) return undefined;
    if (badgeType === "new") return "new";
    if (theme === "dark") return "promo-inverse";
    return "promo";
  };

  return (
    <div
      className={cn("hero-block", {
        "hero-block--light": theme === "light",
      })}
      {...liveInspector?.heroBlock}
    >
      <div className="hero-block__top-section">
        {iconImage && (
          <img className="hero-block__icon-image" alt="icon" src={iconImage} />
        )}
        <div className="hero-block__title-section">
          {badgeType && (
            <div>
              <Badge
                contrast="high-contrast"
                variant="iconAndLabel"
                label={locale[badgeType][node_locale]}
                // we always have a badge theme if badgeType is not undefined
                theme={getBadgeTheme()!}
              />
            </div>
          )}
          <TitleTag className={`hero-block__title-${titleSize}`}>
            {title}
          </TitleTag>
        </div>
      </div>
      {price && <div className="hero-block__price">{price}</div>}
      <div className="hero-block__description">{description}</div>
      {checkList && <div className="hero-block__check-list">{checkList}</div>}
      <div className="hero-block__list-cta">{listCta}</div>
    </div>
  );
};

export default HeroBlock;
